import { Link } from 'react-router-dom';

interface ModuleCardProps {
  id: string;
  icon: string;
  title: string;
  description: string;
  color: string;
  features: string[];
  grade: string;
  level: string;
}

export default function ModuleCard({ id, icon, title, description, color, features, grade, level }: ModuleCardProps) {
  const getModuleLink = () => {
    const moduleLinks: Record<string, string> = {
      'neural-network': '/middle/neural-network',
      'agent-builder': '/middle/agent-builder',
      'ml-playground': '/middle/ml-playground',
      'interdisciplinary-project': '/middle/interdisciplinary-project',
      'iot-simulator': '/middle/iot-simulator',
      'prompt-lab': '/middle/prompt-lab'
    };
    return moduleLinks[id] || null;
  };

  const handleClick = () => {
    const link = getModuleLink();
    if (!link) {
      alert('该模块正在开发中，敬请期待！');
    }
  };

  const moduleLink = getModuleLink();
  const CardContent = (
    <>
      <div className={`w-16 h-16 bg-gradient-to-br from-${color}-400 to-${color}-600 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
        <i className={`${icon} text-3xl text-white`}></i>
      </div>

      <h3 className="text-xl font-bold text-gray-900 mb-3">{title}</h3>
      <p className="text-gray-600 mb-4 leading-relaxed">{description}</p>

      <div className="space-y-2 mb-6">
        {features.map((feature, idx) => (
          <div key={idx} className="flex items-center space-x-2 text-sm text-gray-700">
            <i className={`ri-checkbox-circle-fill text-${color}-600`}></i>
            <span>{feature}</span>
          </div>
        ))}
      </div>

      <div className="flex items-center justify-between pt-4 border-t border-gray-200">
        <span className={`px-3 py-1 bg-${color}-100 text-${color}-700 rounded-full text-sm font-semibold`}>
          {grade}
        </span>
        <span className={`px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs`}>
          {level === 'basic' ? '基础' : level === 'core' ? '核心' : '进阶'}
        </span>
      </div>

      <button className={`w-full mt-6 px-6 py-3 bg-gradient-to-r from-${color}-500 to-${color}-600 text-white rounded-lg font-semibold hover:from-${color}-600 hover:to-${color}-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer`}>
        开始体验
      </button>
    </>
  );

  if (moduleLink) {
    return (
      <Link to={moduleLink} className="block bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-all group cursor-pointer">
        {CardContent}
      </Link>
    );
  }

  return (
    <div onClick={handleClick} className="bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-all group cursor-pointer">
      {CardContent}
    </div>
  );
}
